// extracted by mini-css-extract-plugin
export var chevronIcon = "_43-2";
export var teamName = "_43-1";
export var teamSwitcherButton = "_43-0";